export function getStatus(booking) {
  return booking && booking.state === 'NO_SHOW'
    ? 'No show - Unscheduled'
    : 'Unscheduled'
}
